import { NavLink } from 'react-router-dom';
import { IconChart } from '../ui/icons';

function relativeTime(value) {
  if (!value) return null;
  const then = new Date(value).getTime();
  if (Number.isNaN(then)) return null;
  const diffMs = Date.now() - then;
  const mins = Math.round(diffMs / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  return `${days}d ago`;
}

/**
 * Navigation-only report tile matching the Figma Report Center card:
 * icon, title, description, meta row (Live · CSV / PDF · Updated), Open →.
 *
 * `updatedAt` only renders when the backend supplies a real timestamp — we do
 * not fabricate an "Updated Nm ago" value.
 * @param {{ to: string, title: string, body?: string, updatedAt?: string, live?: boolean }} props
 */
export function ReportTile({ to, title, body, updatedAt, live = true }) {
  const updated = relativeTime(updatedAt);
  return (
    <NavLink
      to={to}
      className="group flex h-full flex-col rounded-2xl border border-eorig-border bg-white p-5 shadow-eorig-card transition-colors hover:border-eorig-cyan/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-eorig-cyan/35"
    >
      <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-eorig-surface text-eorig-navy-600">
        <IconChart className="h-4 w-4" />
      </span>

      <h3 className="mt-3 text-sm font-semibold text-eorig-ink group-hover:text-eorig-navy-600">
        {title}
      </h3>
      {body ? (
        <p className="mt-1 text-xs leading-relaxed text-eorig-muted">{body}</p>
      ) : null}

      <div className="mt-4 flex flex-wrap items-center gap-2 text-[11px] text-eorig-muted">
        {live ? (
          <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 font-semibold text-emerald-700">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" aria-hidden />
            Live
          </span>
        ) : (
          <span className="inline-flex items-center gap-1 rounded-full bg-eorig-surface px-2 py-0.5 font-semibold text-eorig-muted">
            Not wired
          </span>
        )}
        {live ? <span className="font-medium">CSV / PDF</span> : null}
        {updated ? <span>Updated {updated}</span> : null}
      </div>

      <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-eorig-navy-600 group-hover:text-eorig-cyan">
        Open →
      </span>
    </NavLink>
  );
}
